import axios from '../base/axios';
import API_KEY from './key';

const GET_TVCOMEDY = 'flixfrenzy/redux/GET_TVCOMEDY';

// eslint-disable-next-line default-param-last
const tvComedyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVCOMEDY:
      return action.payload;
    default:
      return state;
  }
};

export const getTvComedy = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=35`).then((res) => {
    dispatch({
      type: GET_TVCOMEDY,
      payload: res.data,
    });
  });
};

export default tvComedyReducer;
